import { useRef, useCallback } from 'react'

export function useDebounceScan(delay = 3000) {
  const lastScannedTimeRef = useRef(0)
  const lastScannedTextRef = useRef('')

  const checkAndScan = useCallback((decodedText, callback) => {
    const now = Date.now()
    const isSameText = decodedText === lastScannedTextRef.current
    const isWithinDelay = now - lastScannedTimeRef.current < delay

    if (isSameText && isWithinDelay) {
      // Ignora o scan pois e o mesmo texto dentro do delay
      return false
    }

    lastScannedTextRef.current = decodedText
    lastScannedTimeRef.current = now

    // Executa o callback de sucesso
    callback(decodedText)
    return true
  }, [delay])

  const clearDebounce = useCallback(() => {
    lastScannedTextRef.current = ''
    lastScannedTimeRef.current = 0
  }, [])

  return { checkAndScan, clearDebounce }
}
